// extracted by mini-css-extract-plugin
var _1 = "OneColumnPage-module__container--h_zCz";
var _2 = "OneColumnPage-module__content--isXOt";
export { _1 as "container", _2 as "content" }
